"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LanguageSetting = void 0;
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreLocaleActions = require("01_core/reducers/coreLocaleActions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _SimpleSettingDialog = _interopRequireDefault(require("../common/components/SimpleSettingDialog"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 言語設定ダイアログ
 * @prop {bool} open - 開閉フラグ
 */
const LanguageSetting = function (props) {
  const {
    open,
    handleClose,
    language,
    getCodeItems,
    callAPI,
    clearConditions,
    setLanguage
  } = props;
  const changeLanguage = value => {
    const prevLang = language;
    if (prevLang !== value) {
      clearConditions();
      callAPI(_APIs.UPDATE_LOCALE, {
        nextLang: value
      }).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setLanguage(value);
        } else {
          setLanguage(prevLang);
        }
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_SimpleSettingDialog.default, {
    open: open,
    onChange: changeLanguage,
    handleClose: handleClose,
    value: language,
    titleId: _labelConsts.LABEL.CORE_LANGUAGE_SETTING,
    items: getCodeItems(_CodeConsts.CODE.LOCALE.KBN)
  });
};
exports.LanguageSetting = LanguageSetting;
LanguageSetting.propTypes = {
  open: _propTypes.default.bool.isRequired
};
const mapStateToProps = state => {
  return {
    language: state.coreLocale.language
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setLanguage: language => dispatch(_coreLocaleActions.coreLocaleActions[_coreLocaleActions.TYPES_LOCALE.SET_LANGUAGE](language)),
    clearConditions: () => dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.CLEAR]())
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _CodeUtil.withCodeUtil)((0, _CallAPI.withCallAPI)(LanguageSetting)));